




































































































































































































































































































































































































































































































































































































// @ is an alias to /src
import Vue from "vue";
import {
  RouteRepo,
  IRoute,
  IRouteContent,
  IRouteNotition,
  IRouteQuestion,
  IRouteNotitionContent,
} from "../libs/RouteRepository";
import { FaqRepo, IFaq } from "../libs/FaqRepository";
import { Config } from "../libs/Config";
//@ts-ignore
import BasicAudioPlayer from "../components/BasicAudioPlayer";
//@ts-ignore
import { gmapApi } from "vue2-google-maps";
import Vue2Filters from "vue2-filters";
import NoSleep from "nosleep.js";

export default Vue.extend({
  name: "Home",
  components: {
    BasicAudioPlayer,
  },
  mixins: [Vue2Filters.mixin],
  data() {
    return {
      watchId: undefined as number | undefined,
      markers: [] as any,
      imageHost: Config.ImageUrl,
      routeId: this.$route.params["id"],
      route: undefined as IRoute | undefined,
      intro: undefined as IRouteContent | undefined,
      currentRouteContent: undefined as IRouteContent | undefined,
      notitions: [] as IRouteNotition[],
      routeQuestions: [] as IRouteQuestion[],
      faq: [] as IFaq[],
      linePath: [
        { lat: 51.229465, lng: 2.923903 },
        { lat: 51.2468889, lng: 2.952027777777778 },
      ],
      audioSound: undefined as HTMLAudioElement | undefined,
      viewMode: "map",
      currentStep: 0,
      maxRoutePoint: 0,
      directionsService: undefined as any,
      directionsDisplay: undefined as any,
      currentPostion: undefined as any,
      mapCenter: { lat: 51.128403, lng: 2.684077 },
      showPopup: false,
      rangePopupActive: false,
      showNotitions: false,
      showSendNotifications: false,
      showLegendPopup: false,
      showObstructionPopup: false,
      currentNotition: "",
      polylineOptionsActual: undefined as any,
      notificationForm: {
        firstName: "",
        privacy: false,
        email: "",
        confirmEmail: "",
        contactMe: false,
        errors: [] as string[],
      },
      mapOptions: {
        fullscreenControl: false,
        mapTypeControl: false,
        disableDefaultUI: true,
      },
      locationMessage:"",
      locationNotDetermined: false
    };
  },
  methods: {
    setCurrentNotition: function (id: string) {
      if(this.currentNotition === id)
        this.currentNotition = "";
     else
      this.currentNotition = id;
    },
    mark(event: any) {
      console.log(event.latLng.lat());
      console.log(event.latLng.lng());
    },
    getUserLocation: function () {
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
        desiredAccuracy: 0,
        frequency: 1,
      };
      this.watchId = navigator.geolocation.watchPosition(
        this.onUserLocationSuccess,
        this.onUserLocationError,
        options
      );

        localStorage.setItem("watchId", this.watchId + "");

    },
    onUserLocationSuccess: function (position: any) {
      var str =
        "Latitude: " +
        position.coords.latitude +
        "<br>" +
        "Longitude: " +
        position.coords.longitude +
        "<br>" +
        "Timestamp: " +
        position.timestamp +
        "<br>\r\n";

      console.log(str);

      this.currentPostion = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
      this.checkRoutePointsInRange();
      this.locationNotDetermined = false;
    },
    onUserLocationError: function (error: any) {
      console.log(
        "code: " + error.code + "\n" + "message: " + error.message + "\n"
      );

      if (this.$route.name == "route") {
        this.$swal({
              title: "Opgepast",
              html: this.locationMessage,
              icon: 'error',
              confirmButtonText: "Sluiten",
              showCloseButton: true
        });
      }
      
      this.locationNotDetermined = true;
    },
    // getUserLocation : function(){
    //   var self = this;
    //     // Try HTML5 geolocation.
    //     if (navigator.geolocation) {
    //       navigator.geolocation.getCurrentPosition(
    //         function (position) {
    //           console.log(position);

    //         },
    //         function () {
    //           console.log('cannot get position');
    //         }
    //       );
    //     } else {
    //       console.log('browser no support man');
    //       // Browser doesn't support Geolocation
    //     }
    // },
    showLegend: function () {
      this.showSendNotifications = false;
      this.showPopup = false;
      this.showNotitions = false;
      this.showLegendPopup = true;
      this.showObstructionPopup = false;
    },
    sendNotitionsPopup: function () {
      this.showSendNotifications = true;
      this.showPopup = false;
      this.showNotitions = false;
      this.showLegendPopup = false;
      this.showObstructionPopup = false;
    },
    sendNotifications: async function () {
      this.notificationForm.errors = [];
      console.log(this.notificationForm);
      if (this.notificationForm.firstName == "") {
        this.notificationForm.errors.push("firstName");
      }

      if (this.notificationForm.email == "") {
        this.notificationForm.errors.push("email");
      }

      if (this.notificationForm.email != this.notificationForm.confirmEmail) {
        this.notificationForm.errors.push("confirmEmail");
      }

      if (this.notificationForm.privacy == false) {
        this.notificationForm.errors.push("privacy");
      }

      if (this.notificationForm.errors.length !== 0) {
        return;
      }
      var existingCode = localStorage.getItem(this.routeId);

      var success = await RouteRepo.sendNotitions(
        this.notificationForm.firstName,
        this.notificationForm.email,
        existingCode,
        this.notificationForm.contactMe,
        this.notitions
      );
      if (success) {
        this.showSendNotifications = false;
        this.$swal("Succes", "Je zal jouw notities via mail ontvangen.");
      } else {
        this.showSendNotifications = false;
        this.$swal(
          "Foutmelding",
          "Er is een fout opgetreden bij het opslaan van jouw notities."
        );
      }
    },
    openNotitions: function () {
      //check if all objects are filled in
      console.log(this.visitedRoutePoints);
      
      for (let index = 0; index < this.visitedRoutePoints.length; index++) {
        const element = this.visitedRoutePoints[index];
        var result = this.notitions.find((x) => x.routeContentId == element.id);
        var convertedArr = [] as IRouteNotitionContent[];
        console.log(element.sprint);
        console.log(this.routeQuestions);
        for (let subIndex = 0; subIndex < element.sprint.length; subIndex++) {
          const subElement = element.sprint[subIndex];
          var routeQuestionsArr = this.routeQuestions.filter(
            (x) => x.sprintId == subElement.id
          );
          for (let index = 0; index < routeQuestionsArr.length; index++) {
            const element = routeQuestionsArr[index];
            convertedArr.push(
              JSON.parse(
                JSON.stringify({
                  title: element.question,
                  content: "",
                  routeQuestionId: element.id,
                  sprintId: subElement.id,
                  sprintDisplayOrder: subElement.displayOrder,
                  displayOrder: element.displayOrder,
                })
              )
            );
          }
          convertedArr.push(
            JSON.parse(
              JSON.stringify({
                title: "Vrije notitie",
                content: "",
                routeQuestionId: "",
                sprintId: subElement.id,
                sprintDisplayOrder: subElement.displayOrder,
                displayOrder: 9999,
              })
            )
          );
        }

        if (result == undefined) {
          this.notitions.unshift({
            routeContentId: element.id,
            items: convertedArr,
            displayOrder : element.routeOrder === undefined ? 999 : element.routeOrder
          });
        }
      }
      console.log('notitions');
      console.log(this.notitions);

      this.notitions.sort(function(a, b) {
        var sortParam1 = a.displayOrder !== undefined ? a.displayOrder : 999;
          var sortParam2 = b.displayOrder !== undefined ? b.displayOrder : 999;

          return sortParam1 - sortParam2;
      });

      console.log('sorted notitions');
      console.log(this.notitions);



      this.showSendNotifications = false;
      this.showNotitions = true;
      //@ts-ignore
      this.currentNotition = this.currentRouteContent.id;
      // this.showPopup = false;
      // this.showLegendPopup = false;
      // this.showObstructionPopup = false;
      console.log(this.visitedRoutePoints);
      console.log("grouped notitions");
      for (let index = 0; index < this.notitions.length; index++) {
        console.log(this.groupBy(this.notitions[index].items, "sprintId"));
      }
    },
    closeNotitions: function () {
      this.showPopup = true;
      this.showNotitions = false;
    },
    // update the content of the note with the given routecontent id and routequestionid
    updateNote: function (
      event: Event,
      routeContentId: string,
      routeQuestionId: string,
      sprintId: string
    ) {
      var notes = this.notitions.find(
        (n) => n.routeContentId == routeContentId
      );
      console.log(notes);
      var note = notes?.items.find(
        (i) => i.sprintId == sprintId && i.routeQuestionId == routeQuestionId
      );
      var el = event.target as any;
      if (!note) return;
      note.content = el.value;
      console.log(event.target);
    },
    centerMap: function () {
      if (this.currentPostion !== undefined) {
        this.mapCenter.lat = this.currentPostion.latitude;
        this.mapCenter.lng = this.currentPostion.longitude;
      }
    },
    getRouteNameById: function (routeId: any) {
      if (this.route == undefined) {
        return "";
      }
      var output = this.route.routeContent.filter((x) => x.id == routeId);
      if (output.length == 0) {
        return "";
      } else {
        return output[0].name;
      }
    },
    redirectAppRoute: function (latitude: any, longitude: any) {
      var redirectUrl = "https://www.google.com/maps/dir/?api=1";
      redirectUrl +=
        "&origin=" +
        this.currentPostion.latitude +
        "," +
        this.currentPostion.longitude;
      redirectUrl += "&destination=" + longitude + "," + latitude;
      redirectUrl += "&travelmode=walking";
      window.open(redirectUrl, "_blank");
    },
    checkRoutePointsInRange: function () {
      for (let index = 0; index < this.routePoints.length; index++) {
        const element = this.routePoints[index];
        //@ts-ignore
        var routePointPosition = new this.google.maps.LatLng(
          element.latitude,
          element.longitude
        );
        //@ts-ignore
        var personPosition = new this.google.maps.LatLng(
          this.currentPostion.longitude,
          this.currentPostion.latitude
        );
        //@ts-ignore
        var distance = this.google.maps.geometry.spherical.computeDistanceBetween(
          routePointPosition,
          personPosition
        ); //distance in meters between your location and the marker
        if (
          distance <= this.routePoints[index].distanceNotification &&
          this.routePoints[index].askedInRange != true &&
          this.rangePopupActive == false
        ) {
          this.rangePopupActive = true;
          if (this.audioSound !== undefined) {
            this.audioSound.src = "/sound/notification.wav";
            this.audioSound.play();
          }

          this.routePointOpenDialog(index);
          break;
        }
      }
    },
    closePopup: function () {
      this.showSendNotifications = false;
      this.showPopup = false;
      this.showNotitions = false;
      this.showLegendPopup = false;
      this.showObstructionPopup = false;
    },
    setStep: function (step: any) {
      this.currentStep = step;
    },
    getSprintName: function (sprintId: string) {
      for (let index = 0; index < this.visitedRoutePoints.length; index++) {
        const element = this.visitedRoutePoints[index];
        var sprint = element.sprint.find((f) => f.id == sprintId);
        if (sprint !== undefined) {
          return sprint.name;
        }
      }
      return "";
    },
    mapViewMode : function(){
        var self = this;

        this.getUserLocation();

        //@ts-ignore
        this.$refs.mapRef.$mapPromise.then((map) => {
          //your code here
          //E.g. for directions

          //@ts-ignore
          self.directionsService = new self.google.maps.DirectionsService();
          //@ts-ignore

          console.log("inmap");
          console.log(self.routePointsWaypoints);
          var groupedWayPoints = self.groupBy(
            self.routePointsWaypoints,
            "routeGroup"
          );
          console.log(groupedWayPoints);
          var counter = 1;
          for (var key in groupedWayPoints) {
            if (key == null || key == "null") {
              continue;
            }
            const element = groupedWayPoints[key];
            console.log(element);
            var waypoints = [];
            for (var i = 0; i < element.length; i++) {
              if (i != 0 && i != element.length - 1) {
                waypoints.push({
                  //@ts-ignore
                  location: new self.google.maps.LatLng(
                    element[i].longitude,
                    element[i].latitude
                  ),
                  stopover: true,
                });
              }
            }
            console.log(waypoints);

            self.directionsService.route(
              {
                //@ts-ignore
                origin: new self.google.maps.LatLng(
                  element[0].longitude,
                  element[0].latitude
                ), // Can be coord or also a search query
                //@ts-ignore
                destination: new self.google.maps.LatLng(
                  element[element.length - 1].longitude,
                  element[element.length - 1].latitude
                ),
                travelMode: "WALKING",
                waypoints: waypoints,
              },
              function (response: any, status: any) {
                console.log(response);
                console.log(status);
                if (status === "OK") {
                  //@ts-ignore
                  var directionsDisplay = new self.google.maps.DirectionsRenderer(
                    {
                      suppressMarkers: true,
                      preserveViewport: true,
                    }
                  );
                  counter++;
                  directionsDisplay.setOptions({
                    polylineOptions: {
                      strokeColor: "#00ada0",
                      strokeOpacity: 1.0,
                      strokeWeight: 4,
                    },
                  });
                  //@ts-ignore
                  directionsDisplay.setMap(self.$refs.mapRef.$mapObject);
                  directionsDisplay.setDirections(response); // draws the polygon to the map
                  //draw markers
                  // for(var i = 0; i < response.routes[0].legs.length;i ++){
                  //   self.markers.push({
                  //     latitude : response.routes[0].legs[i].start_location.lat(),
                  //     longitude : response.routes[0].legs[i].start_location.lng()
                  //   })

                  //   if(i == response.routes[0].legs.length - 1 ){
                  //     self.markers.push({
                  //       latitude : response.routes[0].legs[i].end_location.lat(),
                  //       longitude : response.routes[0].legs[i].end_location.lng()
                  //     })
                  //   }
                  // }
                  console.log(self.routePoints);
                } else {
                  console.log("Directions request failed due to " + status);
                }
              }
            );
            //@ts-ignore

            var bounds = new self.google.maps.LatLngBounds();
            for (let index = 0; index < self.routePoints.length; index++) {
              const element = self.routePoints[index];
              //@ts-ignore
              var myLatLng = new self.google.maps.LatLng({
                lat: element.longitude,
                lng: element.latitude,
              });
              bounds.extend(myLatLng);
            }

            //@ts-ignore
            this.$refs.mapRef.fitBounds(bounds);

            map.fitBounds(bounds);

            setTimeout(() => {
              if (self.currentPostion != undefined) {
                //@ts-ignore
                var routePointPosition = new this.google.maps.LatLng(
                  this.routePoints[0].latitude,
                  this.routePoints[0].longitude
                );
                //@ts-ignore
                var personPosition = new this.google.maps.LatLng(
                  this.currentPostion.longitude,
                  this.currentPostion.latitude
                );
                //@ts-ignore
                var distance = this.google.maps.geometry.spherical.computeDistanceBetween(
                  routePointPosition,
                  personPosition
                ); //distance in meters between your location and the marker
                if (distance < 3000) {
                  self.mapCenter.lat = self.currentPostion.latitude;
                  self.mapCenter.lng = self.currentPostion.longitude;
                  map.setZoom(18);
                }
              }
            }, 2000);
          }
        });
    },
    setViewMode: function (viewMode: any) {
      this.viewMode = viewMode;
      var self = this;

      if (this.viewMode == "map") {
        self.mapViewMode();
      }
    },
    getMarkerIcon: function (index: any) {
      if (index == 0 && this.routeId == "014f457e-c538-48d2-a490-5176945c3a97") {
        return "/img/vrouw-start.png";
      } else if (index === this.routePoints.length - 1) {
        return "/img/flag.png";
      } else {
        if (this.routePoints[index].read) {
          return this.imageHost + this.routePoints[index].iconActive;
        } else {
          return this.imageHost + this.routePoints[index].icon;
        }
      }
    },
    getMarkerSize: function (index: any) {
      if (index == 0 && this.routeId == "014f457e-c538-48d2-a490-5176945c3a97") {
        //@ts-ignore
        return new this.google.maps.Size(25, 50);
      } else if (index === this.routePoints.length - 1) {
        //@ts-ignore
        return new this.google.maps.Size(40, 50);
      } else {
        if (this.routePoints[index].height !== undefined) {
          //@ts-ignore
          var heightConversion = this.routePoints[index].height / 50;
          //@ts-ignore
          var width = this.routePoints[index].width / heightConversion;

          console.log(Math.round(width));
          //@ts-ignore
          return new this.google.maps.Size(Math.round(width), 50);
        }
        //@ts-ignore
        return new this.google.maps.Size(35, 50);
      }
    },

    getMarkerAnchor: function (index: any) {
      if (index == 0 && this.routeId == "014f457e-c538-48d2-a490-5176945c3a97") {
        //@ts-ignore
        return new this.google.maps.Point(12, 25);
      } else if (index === this.routePoints.length - 1) {
        //@ts-ignore
        return new this.google.maps.Point(0, 50);
      } else {
        if (this.routePoints[index].height !== undefined) {
          //@ts-ignore
          var heightConversion = this.routePoints[index].height / 50;

          //@ts-ignore
          var width = this.routePoints[index].width / heightConversion;
          console.log(Math.round(width / 2));

          //@ts-ignore
          return new this.google.maps.Point(Math.round(width / 2), 50);
        }

        //@ts-ignore
        return new this.google.maps.Point(17, 50);
      }
    },
    showMarker: function (index: any) {
      if (this.route === undefined) {
        return;
      }
      // if(this.maxRoutePoint + 1 > index && this.maxRoutePoint != index){
      //   this.$swal('Je bent nog te ver verwijderd van deze locatie');
      //   return;
      // }
      this.showSendNotifications = false;
      this.showNotitions = false;
      this.showLegendPopup = false;
      this.showObstructionPopup = false;

      this.routePoints[index].read = true;

      this.currentRouteContent = this.routePoints[index];
      this.showPopup = true;
      this.currentStep = 0;
      this.maxRoutePoint = index;
      // const media = document.querySelector('video');
      // if(media != null){
      //   media.load();
      //   media.play();
      // }
      // console.log('play audio');
      // console.log(this.audioSound);
      // if(this.audioSound !== undefined){
      //   this.audioSound.src = '/sound/notification.wav';
      //   this.audioSound.play();
      // }

      console.log("routepointopendialog");
      console.log(index);
      console.log(this.routePoints.length);
      if (index == this.routePoints.length - 1) {
        RouteRepo.commitRoute(localStorage.getItem(this.routeId));
      }
    },
    showObstruction: function () {
      if (this.route === undefined) {
        return;
      }

      this.showSendNotifications = false;
      this.showNotitions = false;
      this.showLegendPopup = false;
      this.showObstructionPopup = false;

      this.currentRouteContent = this.route.routeContent.filter(
        (x) => x.type == "Obstruction"
      )[0];
      this.showPopup = true;
      this.currentStep = 0;
    },
    groupByAndSort: function (xs: any[], key: string) {
      var newInput = JSON.parse(JSON.stringify(xs));
      newInput.sort(function (a: any, b: any) {
        if (a.sprintDisplayOrder > b.sprintDisplayOrder) {
          return 1;
        } else if (a.sprintDisplayOrder < b.sprintDisplayOrder) {
          return -1;
        }

        // Else go to the 2nd item
        if (a.displayOrder < b.displayOrder) {
          return -1;
        } else if (a.displayOrder > b.displayOrder) {
          return 1;
        } else {
          // nothing to split them
          return 0;
        }
      });
      console.log("after sort");
      console.log(xs);
      return newInput.reduce(function (rv: any, x: any) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    groupBy: function (xs: any[], key: string) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    },
    routePointOpenDialog: function (index: any) {
      var self = this;
      this.routePoints[index].askedInRange = true;

      this.$swal({
        title:
          "Ben je aan " +
          this.routePoints[index].name +
          " en wens je die te ontdekken?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Nee",
        confirmButtonText: "Ja",
      }).then((result) => {
        if (result.value) {
          self.showMarker(index);
        }
        self.rangePopupActive = false;
      });
    },
    isIos: function () {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(userAgent)) {
        return true;
      } else {
        return (
          navigator.maxTouchPoints &&
          navigator.maxTouchPoints > 2 &&
          /MacIntel/.test(navigator.platform)
        );
      }
    },
    reload(){
      window.location.reload();
    }
  },
  mounted: async function () {
    var self = this;
    this.route = await RouteRepo.getRouteById(this.$route.params["id"]);

    if (this.route !== undefined) {
      this.intro = this.route.routeContent.filter((x) => x.type == "Intro")[0];
    }

    this.faq = await FaqRepo.getAll();

    this.routeQuestions = await RouteRepo.getRouteQuestions(
      this.$route.params["id"]
    );

    if (localStorage.getItem("notes_" + this.routeId)) {
      this.notitions = JSON.parse(
        localStorage.getItem("notes_" + this.routeId) as string
      );
    }

     //this.locationMessage = this.isIos() 
     //       ? "We merken dat je locatie uitgeschakeld staat voor deze browserapp (Safari of Google). Ga naar je instellingen via <img style='width:40px' src='/img/settings-icon-ios.png'> en schakel voor deze browserapp de locatie detectie terug in."
     //       : "We merken dat je locatie uitgeschakeld staat voor deze browserapp. Controleer in je instellingen of deze browserapp en ook deze site toegang hebben om je locatie te gebruiken."


        
      this.locationMessage = this.isIos() 
      ? "Zonder locatie herkenning kan je wel de route zien op de kaart. Activeer je de geolocatie dan zie je ook waar je je bevindt en krijg je een signaal als er een volgende locatie en audio beschikbaar is.<br /><br />Kan je de locatie niet direct activeren, kijk dan in de instellingen van je browser of anderzijds in de instellingen van je smartphone. De parameter die gewijzigd moet worden heet 'locatie'."
      : "Zonder locatie herkenning kan je wel de route zien op de kaart. Activeer je de geolocatie dan zie je ook waar je je bevindt en krijg je een signaal als er een volgende locatie en audio beschikbaar is.<br /><br />Kan je de locatie niet direct activeren, kijk dan in de instellingen van je browser of anderzijds in de instellingen van je smartphone. De parameter die gewijzigd moet worden heet 'locatie'."
    self.mapViewMode();



    // this.routeQuestions.push({
    //   id: "",
    //   sprintId: this.$route.params["id"],
    //   question : "Vrije notitie",
    //   timestamp : ""
    // }as IRouteQuestion)
    // setTimeout(function () {
    //   self.viewMode = "intro";
    // }, 3000);

    //self.setViewMode('map');
  },
  created: async function () {
    var noSleep = new NoSleep();
    // Enable wake lock.
    // (must be wrapped in a user input event handler e.g. a mouse or touch handler)
    document.addEventListener(
      "click",
      function enableNoSleep() {
        document.removeEventListener("click", enableNoSleep, false);
        noSleep.enable();
      },
      false
    );

    this.audioSound = new Audio();
    this.audioSound.play();
  },
  watch: {
    notitions: {
      deep: true,
      handler: function (val) {
        localStorage.setItem(
          "notes_" + this.routeId,
          JSON.stringify(this.notitions)
        );
      },
    },
  },
  computed: {
    google: gmapApi,
    routePoints: function (): IRouteContent[] {
      if (this.route == undefined) {
        return [];
      }
      return this.route.routeContent.filter((x) => x.type == "Point");
    },
    routePointsWaypoints: function (): IRouteContent[] {
      if (this.route == undefined) {
        return [];
      }
      return this.route.routeContent.filter(
        (x) =>
          (x.type == "Point" || x.type == "HiddenRoute") &&
          x.customRoute == false
      );
    },
    customRoutePointsWaypoints: function (): any[] {
      if (this.route == undefined) {
        return [];
      }
      console.log(this.route);
      var polyLineArry = [] as any[];
      var wayPoints = this.route.routeContent.filter(
        (x) =>
          (x.type == "Point" || x.type == "HiddenRoute") &&
          x.customRoute == true
      );
      for (let index = 0; index < wayPoints.length; index++) {
        if (index != wayPoints.length - 1) {
          const element = wayPoints[index];
          const nextElement = wayPoints[index + 1];
          polyLineArry.push([
            { lat: element.longitude, lng: element.latitude },
            { lat: nextElement.longitude, lng: nextElement.latitude },
          ]);
        }
      }
      console.log("poly arr");
      console.log(polyLineArry);
      return polyLineArry;
    },
    visitedRoutePoints: function (): IRouteContent[] {
      if (this.route == undefined) {
        return [];
      }
      console.log("visisitedroute points");
      console.log(
        this.route.routeContent.filter(
          (x) => x.type == "Point" && x.read == true
        )
      );
      return this.route.routeContent.filter(
        (x) => x.type == "Point" && x.read == true
      );
    },
  },
});
